
import request from '../request';

// 列表查询-慢病送药
const getMedDataList = () => {
	return request.post('/api/wx/auth/medApplyList')
}
// 数据保存-慢病送药
const submitMedData = (data) => {
	return request.post('/api/wx/auth/medApply', data)
}
// 文件上传-慢病送药
const uploadMedFile = (data) => {
	return request.post('/api/wx/auth/uploadMedFile', data)
}
// 数据详情-慢病送药
const getMedDetail = (data) => {
	return request.post('/api/web/auth/applyDetail', data)
}
// 地址查询-慢病送药
const getMedAddress = (data) => {
	return request.post('/api/wx/auth/getApplyAddress', data)
}
// 获取当前用户的保单信息
const getUserPolicyinfo = () => {
	return request.post('/api/web/auth/getMedBaseInfo')
}
// 数据保存-获取生成理赔申请书
const getMedApplyImg = (data) => {
	return request.post('/api/wx/auth/createMedApplyImg', data, { responseType: 'blob' })
}
// 文件上传-慢病送药
const uploadMedFileList = (data) => {
	return request.post('/api/wx/auth/uploadMedFileList', data)
}
// 确认签收-慢病送药
const updateApplyDetail = (data) => {
	return request.post('/api/web/auth/updateApplyDetail', data)
}
// 对象数组
export default {
    getMedDataList,
	submitMedData,
	uploadMedFile,
	getMedDetail,
	getMedAddress,
	getUserPolicyinfo,
	getMedApplyImg,
  uploadMedFileList,
	updateApplyDetail
};